export default __webpack_public_path__ + "static/media/pen-white.3c9e4c3c.svg";